module.exports = __webpack_public_path__ + "static/img/1.6ce8f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/1.png
// module id = jq94
// module chunks = 0